import { useState} from "react";
import { PacksSortableKeys, SortDirection } from "lib/types";

type State = {
  direction: SortDirection;
  sortKey: string;
}

type UseListSort = ({ direction, sortKey }: { direction: SortDirection, sortKey: string }) => {
  onSortClick: (sortKey: PacksSortableKeys) => void;
  direction: SortDirection;
  sortKey: string
};

export const useListSort: UseListSort = ({ direction, sortKey }) => {
  const [ state, setState ] = useState<State>({ direction, sortKey });

  const onSortClick = (sortKey: PacksSortableKeys): void => {
    setState({
      ...state,
      direction: sortKey === state.sortKey ? reverseSortOrder() : state.direction,
      sortKey,
    });
  };

  const reverseSortOrder = (): SortDirection => state.direction === SortDirection.asc ? SortDirection.desc : SortDirection.asc;

  return {
    direction: state.direction,
    sortKey: state.sortKey,
    onSortClick,
  }
};
